import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5eb21675"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "questionnaire-fill-out" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "問診票", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheHeaderWithCloseButton = _resolveComponent("TheHeaderWithCloseButton")!
  const _component_QuestionnaireFillOutStepAFillOut = _resolveComponent("QuestionnaireFillOutStepAFillOut")!
  const _component_QuestionnaireFillOutStepBConfirm = _resolveComponent("QuestionnaireFillOutStepBConfirm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_TheHeaderWithCloseButton, { onClose: _ctx.close }, null, 8, ["onClose"]),
    _createElementVNode("main", null, [
      _hoisted_2,
      _withDirectives(_createVNode(_component_QuestionnaireFillOutStepAFillOut, {
        onNext: _ctx.save,
        onPrevious: _ctx.previous
      }, null, 8, ["onNext", "onPrevious"]), [
        [_vShow, _ctx.isQuestionnaireFillOutStepAFillOut]
      ]),
      (_ctx.isQuestionnaireFillOutStepBConfirm)
        ? (_openBlock(), _createBlock(_component_QuestionnaireFillOutStepBConfirm, {
            key: 0,
            questionnaire: _ctx.newQuestionnaire,
            onNext: _ctx.next,
            onPrevious: _ctx.previous
          }, null, 8, ["questionnaire", "onNext", "onPrevious"]))
        : _createCommentVNode("", true)
    ])
  ]))
}